import useToolsCards from 'hooks/useToolsCards';
import useSuccessStoryImages from 'hooks/useSuccessStoryImages';
import { filterPostsFromSplashAndToolbox } from 'components/WebinarPage/utils/postsUtils';

const toolboxCardSections = ({ data }) => {
  const toolCards = useToolsCards();

  const { webinarAd, articleAd, podcastAd, guidesAd } = data.contentfulWebsiteContentHub;

  const sectionsDataTools = toolCards.map(item => {
    return {
      excerpt: { excerpt: item.description.description },
      slug: item.ctaLink,
      title: item.title,
      __typename: 'ContentfulTools',
      featuredImage: item.cover,
      backColor: item.backColor,
    };
  });

  const successStoryImages = useSuccessStoryImages();

  const shuffle = tmp => {
    const arr = [...tmp];

    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }

    return arr;
  };

  const tmp1 = shuffle([...Array(successStoryImages.length).keys()]);
  const tmp2 = tmp1.slice(0, successStoryImages.length - 1);
  const successImageIndexes = tmp1
    .concat(shuffle(tmp2))
    .slice(0, data.allSuccessStory?.nodes.length);

  return [
    {
      category: 'Webinars',
      data: filterPostsFromSplashAndToolbox(data.allContentfulWebinar?.nodes),
      ad: webinarAd,
    },
    {
      category: 'Articles',
      data: data.allArticle?.nodes,
      ad: articleAd,
    },
    {
      category: 'Success Stories',
      data: data.allSuccessStory?.nodes.map((item, index) => {
        return {
          ...item,
          backColorIndex: successImageIndexes[index],
          featuredImage: successStoryImages[successImageIndexes[index]].node.image,
        };
      }),
    },
    {
      category: 'Podcasts',
      data: data.allContentfulPodcast?.nodes,
      ad: podcastAd,
    },
    {
      category: 'Tools',
      data: sectionsDataTools,
    },
    {
      category: 'Guides',
      data: data.allContentfulGatedContentPage?.nodes,
      ad: guidesAd,
    },
  ];
};

export default toolboxCardSections;
